import { helpers } from '../helpers.js';

var carMileage = {
  options: {
    // global options
  },

  selectors: {
    watcher: ".js-car-mileage-watcher",
    mileageBlock: ".js-car-mileage"
  },

  init: function () {
    const self = this;

    self.initCheckboxWatcher();
  },

  initCheckboxWatcher: function () {
    const self = this;

    // Find all checkboxes within the watcher and set initial state
    jQuery(self.selectors.watcher).find('input[type="checkbox"]').each(function() {
      self.setDisplay(jQuery(this));
    });

    // Watch for checkbox change events within the watcher
    jQuery(self.selectors.watcher).on('change', 'input[type="checkbox"]', function() {
      self.setDisplay(jQuery(this));
    });
  },

  setDisplay: function ($checkbox) {
    const self = this;
    const $mileageBlock = jQuery(self.selectors.mileageBlock);
    
    if ($checkbox.is(':checked')) {
      $mileageBlock.addClass('d-none');
    } else {
      $mileageBlock.removeClass('d-none');
    }
  },
}

// Export
export { carMileage };